var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading && _vm.userInformation.userAccount.isAdmin != null)?_c('div',[(_vm.userInformation.userAccount.isAdmin == true)?_c('AdminDashboard'):_c('UserDashboard')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }